import { cas } from '@lib/api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  accessToken?: string;
  selectedTenantId?: string;
  selectedOrganizationId?: string;
  user?: cas.UserInfoResponse;
  allowedTenants?: cas.AllowedTenantResponse[];
  permissions?: cas.FunctionalityAssignment[];
  organizationAuth?: cas.UserOrganizationAuth | null;
}

const initialState: AuthState = {};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: () => ({
      accessToken: undefined,
      selectedTenantId: undefined,
      selectedOrganizationId: undefined,
      user: undefined,
      allowedTenants: [],
      permissions: [],
    }),
    login: (state, { payload }: PayloadAction<AuthState>) => {
      const { accessToken, selectedTenantId, selectedOrganizationId, user, allowedTenants, permissions, organizationAuth } = payload;

      state.accessToken = accessToken;
      state.selectedTenantId = selectedTenantId;
      state.selectedOrganizationId = selectedOrganizationId;
      state.user = user;
      state.allowedTenants = allowedTenants;
      state.permissions = permissions;
      state.organizationAuth = organizationAuth;
    },
    setSelectedtenant: (state, { payload }: PayloadAction<{ selectedTenantId: string }>) => {
      const { selectedTenantId } = payload;

      localStorage.setItem('selectedTenantId', selectedTenantId);
      state.selectedTenantId = selectedTenantId;
    },
    setSelectedOrganization: (state, { payload }: PayloadAction<{ selectedOrganizationId: string }>) => {
      const { selectedOrganizationId } = payload;

      localStorage.setItem('selectedOrganizationId', selectedOrganizationId);
      state.selectedOrganizationId = selectedOrganizationId;
    },
    updateUser: (state, { payload }: PayloadAction<{ user: cas.UserInfoResponse }>) => {
      const { user } = payload;

      state.user = user;
    },
  },
});

export const { logout, login, setSelectedtenant, setSelectedOrganization, updateUser } = authSlice.actions;
